import { Action } from '@ngrx/store';

export class AgreementsAction implements Action {

    public static getAgreement = '[Agreements] get_item';
    public static getAgreementSuccess = '[Agreements] get_item_success';
    public static getAgreementError = '[Agreements] get_item_error';

    public static getAgreementData = '[Agreements] get_agreement_data';
    public static getAgreementDataError = '[Agreements] get_agreement_data_error';
    public static getAgreementDataSuccess = '[Agreements] get_agreement_data_success';

    public static acceptAgreement = '[Agreements] accept';
    public static acceptAgreementError = '[Agreements] accept_error';
    public static acceptAgreementSuccess = '[Agreements] accept_success';

    public static getAccepted = '[Agreements] get_accepted';
    public static getAcceptedError = '[Agreements] get_accepted_error';
    public static getAcceptedSuccess = '[Agreements] get_accepted_success';

    public static downloadAgreement = '[Agreements] download_agreement';
    public static downloadAgreementError = '[Agreements] download_agreement_error';
    public static downloadAgreementSuccess = '[Agreements] download_agreement_success';

    public static getAgreementToAccept = '[Agreements] GetAgreementsToAccept';
    public static setAgreementToAccept = '[Agreements] SetAgreementsToAccept';

    public static getAgreementStatus = '[Agreements] get_agreement_status';
    public static getAgreementStatusError = '[Agreements] get_agreement_status_error';
    public static getAgreementStatusSuccess = '[Agreements] get_agreement_status_success';

    public static getMultipleAgreementsData = '[Agreements] get_multiple_agreements_data';
    public static getMultipleAgreementsDataSuccess = '[Agreements] get_multiple_agreements_data_success';
    public static getMultipleAgreementsDataError = '[Agreements] get_multiple_agreements_data_error';

    public static acceptMultipleAgreements = '[Agreements] accept_multiple_agreements';
    public static acceptMultipleAgreementsSuccess = '[Agreements] accept_multiple_agreements_success';
    public static acceptMultipleAgreementsError = '[Agreements] accept_multiple_agreements_error';

    public static resetSelectedAgreement = '[Agreements] reset_selected_agreement';

    constructor(
        public type: string,
        public payload?: any,
    ) {}
}
